export default __webpack_public_path__ + "static/media/LogoRound.7eb62826.png";